import { jsx as _jsx } from "react/jsx-runtime";
import { NavDropdown } from "react-bootstrap";
import { I18n, Translate } from "react-redux-i18n";
import { saveLocale } from "./locale";
export const KNavLangSelector = ({ locale, translations, onChangeLocale, alignRight }) => {
    return (_jsx(NavDropdown, { id: "locale-dropdown", title: I18n.t(`locale.${locale}`), align: alignRight ? "end" : "start", className: "small", children: Object.keys(translations).map((l, index) => (_jsx(NavDropdown.Item, { onClick: () => {
                saveLocale(l);
                onChangeLocale(l);
            }, children: _jsx(Translate, { value: `locale.${l}` }) }, index))) }));
};
